// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import asterisk01Icon from "@/assets/icons/asterisk-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Asterisk01IconProps = Omit<IconProps, "name">;

export function Asterisk01Icon(props: Asterisk01IconProps): React.ReactNode {
  return <Icon name={asterisk01Icon} {...props} />;
}
